import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/:libraryItemId/document/transactions`;

export type GetLibraryItemTransactionsResponse = {
  status: boolean;
  data: any;
};

export type GetLibraryItemTransactionsDTO = {
  libraryItemId: number;
};

export type GetLibraryItemTransactionsParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getLibraryItemTransactionsQueryKey = {
  all: ['getLibraryItemTransactions'] as const,
  list: (libraryItemId) => [...getLibraryItemTransactionsQueryKey.all, libraryItemId] as const,
};

export const getLibraryItemTransactions = ({
  libraryItemId,
}: GetLibraryItemTransactionsDTO): Promise<GetLibraryItemTransactionsResponse> => {
  const URL = generateRoutePath(url, { libraryItemId });

  return axios.get(URL);
};
type QueryFnType = typeof getLibraryItemTransactions;

type UseGetLibraryItemTransactionsOptions = {
  libraryItemId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryItemTransactions = ({
  libraryItemId,
  config,
}: UseGetLibraryItemTransactionsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getLibraryItemTransactionsQueryKey.all, libraryItemId],
    queryFn: () => getLibraryItemTransactions({ libraryItemId }),
    // staleTime: Infinity,
    cacheTime: 0,
    ...config,
  });
};
